export const HUBBLE_LIQUIDATION_TOKEN_MINT_MAP = {
  btc: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
  srm: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
  ray: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
  msol: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
  ftt: "FTT9rBBrYwcHam4qLvkzzzhrsihYMbZ3k6wJbdoahxAt",
  sol: "11111111111111111111111111111111",
  eth: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
};

export const HUBBLE_TOKEN_SYMBOL_MAP = {
  STSOL: "stSOL",
  LDO: "wLDO",
  DAOSOL: "daoSOL",
  CSTSOL: "cSTSOL",
  CETH: "cETH",
  CSOL: "cSOL",
  CMSOL: "cMSOL",
  CRAY: "cRAY",
};

export const HUBBLE_LIDO_APR_ENDPOINT = "https://api.hubbleprotocol.io/staking/lido?env=mainnet-beta";

export const HUBBLE_STSOL_TOOLTIP_TEXT =
  "Rewards paid in LDO. The Loan to Value ration of your position must be >40% collateral to be eligible for these rewards.";

export const fetchStSOLAPY = async (): Promise<null> => {
  try {
    const response = await fetch(HUBBLE_LIDO_APR_ENDPOINT);
    const data = await response.json();
    return data.apr ? data.apr : null;
  } catch {
    return null;
  }
};
